import React from 'react';
import noop from 'lodash/noop';

function useVideoPlayback(getVideo: () => HTMLVideoElement | null | undefined) {
  const getVideoRef = React.useRef(getVideo);
  getVideoRef.current = getVideo;

  const playPromiseRef = React.useRef<Promise<void> | undefined>(undefined);

  const play = React.useCallback(() => {
    playPromiseRef.current = getVideoRef.current()?.play();
    playPromiseRef.current?.catch(noop);
  }, []);

  const pause = React.useCallback(() => {
    if (playPromiseRef.current !== undefined) {
      playPromiseRef.current.then(() => getVideoRef.current()?.pause()).catch(noop);
    } else {
      getVideoRef.current()?.pause();
    }
  }, []);

  return { play, pause };
}

export default useVideoPlayback;
